import { dataShieldUser } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldUser = /*#__PURE__*/createIcon(dataShieldUser)
export default IconShieldUser
